import script from "./SellProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./SellProduct.vue?vue&type=script&setup=true&lang=js"

import "./SellProduct.vue?vue&type=style&index=0&id=3841d888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3841d888"]])

export default __exports__